import React, { memo, useMemo, useState } from 'react';

import Button from '../../helpers/Button';

import style from './style.module.css';

const weightingConfig = [
  { name: 'closed_deals', label: 'Closed Deals', defaultValue: 10 },
  { name: 'approval_lists_sent', label: 'Approval Lists Sent', defaultValue: 0 },
  { name: 'targets_sent', label: 'Targets Sent', defaultValue: 0 },
  { name: 'targets_approved', label: 'Targets Approved', defaultValue: 0 },
  { name: 'approval_rate_percent', label: 'Approval Rate', defaultValue: 0 },
  { name: 'contacted_rate_percent', label: 'Contact Rate', defaultValue: 0 },
  { name: 'leads', label: 'Leads', defaultValue: 0 },
  { name: 'leads_rate_percent', label: 'Lead Rate', defaultValue: 15 },
  { name: 'conference_calls', label: 'Conf. Calls', defaultValue: 0 },
  { name: 'conference_calls_rate_percent', label: 'CC Rate', defaultValue: 15 },
  { name: 'visits', label: 'Visits', defaultValue: 0 },
  { name: 'visits_rate_percent', label: 'Visit Rate', defaultValue: 15 },
  { name: 'offers_and_better', label: 'O&B', defaultValue: 20 },
  { name: 'offers_and_better_rate_percent', label: 'O&B Rate', defaultValue: 25 },
];

export const initialValues = Object.fromEntries(weightingConfig.map(({ name, defaultValue }) => [name, defaultValue]));

const FilterComponent = ({ readOnly, loading, onChange, onFilter }) => {
  const [error, setError] = useState(false);

  const handleChange = event => {
    const { form } = event.currentTarget;

    if (!form) return;

    const formData = new FormData(form);

    onChange(formData);
  };

  const handleFilter = event => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const sum = Array.from(formData.values()).reduce((accumulator, value) => accumulator + Number(value), 0);

    setError(sum !== 100);

    if (sum === 100) {
      onFilter(formData);
    }
  };

  const commonProps = useMemo(
    () => ({
      className: 'form-control',
      min: 0,
      max: 100,
      type: 'number',
      readOnly,
      onChange: handleChange,
    }),
    [readOnly],
  );

  return (
    <>
      <form className={style.host} onSubmit={handleFilter}>
        {weightingConfig.map(field => (
          <div key={field.name} className={style.field}>
            <label className="field-label" htmlFor={field.name}>
              {field.label}
            </label>
            <input {...commonProps} defaultValue={field.defaultValue} id={field.name} name={field.name} />
          </div>
        ))}
        <Button className="btn-primary" disabled={readOnly || loading} type="submit">
          Apply
        </Button>
      </form>
      {error && <p className="text-danger mt8 mb0">Sum of weighting must be 100%</p>}
    </>
  );
};

/** Weighting form of the retainer health report. */
export const Filter = memo(FilterComponent);
